function validateMallBaseUrl(mallBaseUrl: string): URL {
  const base = new URL(mallBaseUrl);
  if (base.protocol !== "https:" || base.username || base.password || base.pathname !== "/" || base.search || base.hash) {
    throw new Error("商城配置不是安全的 HTTPS Origin");
  }
  return base;
}

function openExternal(target: URL): void {
  const popup = window.open(target.href, "_blank", "noopener,noreferrer");
  if (popup) popup.opener = null;
}

export function getMallHomeHref(mallBaseUrl: string): string | null {
  try {
    return validateMallBaseUrl(mallBaseUrl).href;
  } catch {
    return null;
  }
}

export function getMallProductHref(productUrl: string): string | null {
  try {
    const target = new URL(productUrl);
    if (
      target.protocol !== "https:"
      || target.username
      || target.password
      || target.hash
    ) return null;
    return target.href;
  } catch {
    return null;
  }
}

export function openMallHome(mallBaseUrl: string): void {
  const href = getMallHomeHref(mallBaseUrl);
  if (!href) throw new Error("商城配置不是安全的 HTTPS Origin");
  openExternal(new URL(href));
}

export function openMallProduct(productUrl: string): void {
  const href = getMallProductHref(productUrl);
  if (!href) throw new Error("该商城链接不是安全的 HTTPS 链接");
  openExternal(new URL(href));
}
